import { useEffect, useRef, useState } from 'react';
import { HubConnectionBuilder, HttpTransportType, LogLevel } from '@microsoft/signalr';
import { useDispatch, useSelector } from 'react-redux';
import { fetchToken, sendControlRequest, sendMessageToNotification, sendMessageToTeam, updateMessageProperty, updateMessages, updateReadenMessage } from '../store/signalRMessages-actions'
import { ControlRequestTypeEnum } from '../models/ControlRequestTypeEnum';
import DynamicMessage from '../UI/Popups/DynamicMessage/DynamicMessage';
import { DynamicMessageTypeEnum } from '../models/DynamicMessageTypeEnum';
import { useParams } from 'react-router-dom';
import { notificationsApi } from '../../../utils';
import { throwApiError } from '../store/error-handling-actions';

export function useSignalR(setMessage) {

    const dispatch = useDispatch()
    const token = useSelector(state => state.signalRMessages?.token);
    const messages = useSelector(state => state.signalRMessages?.messages);
    const uiData = useSelector((state) => state.general.uiData);
    const prevMessagesRef = useRef([]);
    const user = useSelector((state) => state.auth.user);
    const { texts } = useSelector((state) => state.translate);
    const { lessonId } = useParams();

    useEffect(() => {
        if (uiData && uiData.BlockingTeamwork)
            dispatch(fetchToken())
    }, [uiData])

    useEffect(() => {
        if (uiData && uiData.BlockingTeamwork) {
            let connection;
            if (token) {
                connection = new HubConnectionBuilder()
                    .withUrl(window.config.NotificatinUrl + "/RT/Notification", {
                        accessTokenFactory: () => token,
                        skipNegotiation: true,
                        transport: HttpTransportType.WebSockets
                    })
                    .withAutomaticReconnect()
                    .configureLogging(LogLevel.Information)
                    .build();

                try {
                    connection.start();
                } catch (err) {
                    console.log(err);
                    setTimeout(() => {
                        try {
                            connection.start()
                        }
                        catch (e) {
                            console.log(e)
                        }
                    }, 5000);
                }
                connection.on(ControlRequestTypeEnum.SendControlRequest, (data) => {
                    let notificationMessage = {
                        method: ControlRequestTypeEnum.GetControlRequest,
                        data: { lessonId: data?.lessonId }
                    }
                    notificationsApi.notificationsSendUserUserExternalIdPost(data?.user, { notificationMessage: notificationMessage }, (error, resdata, response) => {
                        if (error) {
                            dispatch(throwApiError({ userMessage: "send message to notification", error: error, statusCode: response?.statusCode, message: "notificationsSendUserUserExternalIdPost " + error.message, level: 2, component: "", line: 36 }))
                        }
                        else {
                        }
                    })
                    dispatch(updateMessages(ControlRequestTypeEnum.SendControlRequest, data?.lessonId, data?.user, data?.studyGroupId))
                })
                connection.on(ControlRequestTypeEnum.GiveControl, (data) => {
                    dispatch(updateMessages(ControlRequestTypeEnum.GiveControl, data?.lessonId, data?.user, data?.studyGroupId))
                })
                connection.on(ControlRequestTypeEnum.Reject, (data) => {
                    dispatch(updateMessages(ControlRequestTypeEnum.Reject, data?.lessonId, data?.user, data?.studyGroupId))
                })
                connection.on(ControlRequestTypeEnum.GetControlRequest, (data) => {
                    dispatch(updateMessages(ControlRequestTypeEnum.GetControlRequest, data?.lessonId, data?.user, data?.studyGroupId))
                })

                return () => {
                    connection.stop();
                }
            }

        }
    }, [token, uiData])

    useEffect(() => {
        if (uiData && uiData.BlockingTeamwork) {
            let timeoutId;
            setMessage(null);
            const latestMessage = messages[messages?.length - 1];
            switch (latestMessage?.message) {
                case ControlRequestTypeEnum.SendControlRequest:
                    if (messages?.length !== prevMessagesRef.current?.length) {
                        if (!window.location.pathname.includes('lesson') && !window.location.pathname.includes('project') && !latestMessage?.isRead) {
                            setMessage(
                                <DynamicMessage
                                    type={DynamicMessageTypeEnum.Warn}
                                    title={texts.teamMemberEditRequestConfirmation}
                                    cancelText={texts.reject}
                                    cancelFunc={() => {
                                        dispatch(updateReadenMessage(true))
                                        dispatch(updateMessageProperty(false));
                                        sendMessageToTeam(token, ControlRequestTypeEnum.Reject, latestMessage?.userFrom, null, user, null, setMessage, null);
                                    }}
                                    confirmText={texts.giveControl}
                                    confirmFunc={() => {
                                        dispatch(updateReadenMessage(true))
                                        dispatch(updateMessageProperty(true));
                                        sendControlRequest(token, ControlRequestTypeEnum.GiveControl, messages[messages?.length - 1]?.userFrom, null, user, null, setMessage, null, messages, dispatch);
                                    }} />);
                        }
                        timeoutId = setTimeout(() => {
                            sendControlRequest(token, ControlRequestTypeEnum.GiveControl, messages[messages?.length - 1]?.userFrom, null, user, null, setMessage, null, messages, dispatch);
                            dispatch(updateMessageProperty(true));
                            dispatch(updateReadenMessage(true));
                            sendMessageToTeam(token, ControlRequestTypeEnum.GiveControl, latestMessage?.userFrom, null, user, null, setMessage, null);
                            setMessage(null);
                        }, 40000);
                    }
                    break;

                default:
                    break;
            }
            prevMessagesRef.current = messages;
            return () => {
                clearTimeout(timeoutId);
            };
        }
    }, [messages, uiData]);

}

export default useSignalR